import { render, staticRenderFns } from "./DadosRelatoriosAdmin.vue?vue&type=template&id=5a1098e0&scoped=true"
import script from "./DadosRelatoriosAdmin.vue?vue&type=script&lang=js"
export * from "./DadosRelatoriosAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1098e0",
  null
  
)

export default component.exports